<template>
  <div class="survey-edit">
    <side-bar></side-bar>
    <router-view></router-view>
  </div>
</template>
<script>
import SideBar from "./components/sidebar";
export default {
  data() {
    return {};
  },
  components: {
    SideBar
  }
};
</script>
<style lang="less" scoped>
.survey-edit {
  height: 100vh;
  background-color: #f3f5f6;
  overflow-y: auto;
}
</style>
